import React from 'react';
import PropTypes from 'prop-types';
import PatientSearchBar from './PatientSearchBar';

// Shared chart-search wiring for the redesigned EMA/Kareo modals: the patient match
// strip that auto-searches on mount by full name + DOB and lets staff bind an
// existing chart. Both Send-to-Chart and Create-New-Chart render it identically;
// callers gate it on having EMR-API credentials and no chart bound yet.
const PatientMatchSearch = ({
  getEmaPatients, getTebraPatients,
  isKareo, firstName, middleName, lastName, dob, onSelectPatient, gatewayEmaSearch,
  onSearchComplete, onIdentitySearchPending, searchResult,
}) => (
  <PatientSearchBar
    getEmaPatients={getEmaPatients}
    getTebraPatients={getTebraPatients}
    isKareo={isKareo}
    gatewayEmaSearch={gatewayEmaSearch}
    showRelaxedAlert
    defaultSearchType="nameAndDOB"
    autoSearchOnMount
    prefill={{
      firstName, middleName, lastName, dob,
    }}
    onSelectPatient={onSelectPatient}
    onSearchComplete={onSearchComplete}
    onIdentitySearchPending={onIdentitySearchPending}
    searchResult={searchResult}
  />
);

PatientMatchSearch.propTypes = {
  getEmaPatients: PropTypes.func.isRequired,
  getTebraPatients: PropTypes.func.isRequired,
  isKareo: PropTypes.bool,
  gatewayEmaSearch: PropTypes.bool,
  firstName: PropTypes.string,
  middleName: PropTypes.string,
  lastName: PropTypes.string,
  dob: PropTypes.string,
  onSelectPatient: PropTypes.func.isRequired,
  onSearchComplete: PropTypes.func,
  onIdentitySearchPending: PropTypes.func,
  searchResult: PropTypes.object,
};

PatientMatchSearch.defaultProps = {
  isKareo: false,
  gatewayEmaSearch: false,
  firstName: '',
  middleName: '',
  lastName: '',
  dob: '',
  onSearchComplete: () => {},
  onIdentitySearchPending: () => {},
  searchResult: null,
};

export default PatientMatchSearch;
